import React from 'react';

import { Box, Card, Button, Typography, Grid, CardContent, CardActions, Divider, CardHeader, Avatar, Chip } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import PhoneIcon from "@material-ui/icons/PhoneIphoneTwoTone"
import MessageIcon from "@material-ui/icons/SmsTwoTone"
import RouterRoundedIcon from '@material-ui/icons/RouterRounded';
import SimCardTwoToneIcon from '@material-ui/icons/SimCardTwoTone';
import MemoryTwoToneIcon from '@material-ui/icons/MemoryTwoTone';
import InfoTwoToneIcon from '@material-ui/icons/InfoTwoTone';
import AccessTimeTwoToneIcon from '@material-ui/icons/AccessTimeTwoTone';
import { orange, deepOrange, purple, blue } from "@material-ui/core/colors/"
import ReadMoreIcon from '@material-ui/icons/MoreHorizTwoTone';
import SignalCellularAltTwoToneIcon from '@material-ui/icons/SignalCellularAltTwoTone';
import VpnLockTwoToneIcon from '@material-ui/icons/VpnLockTwoTone';
import FingerprintTwoToneIcon from '@material-ui/icons/FingerprintTwoTone';


const MessagesCards = (props) => {
    const fmtDateTime = (isoString, timeZone) => {
        try {
            const dt = new Date(isoString)
            const tz = timeZone || 'UTC'

            // Get localized Y-M-D H:m:s parts
            const parts = new Intl.DateTimeFormat('en-CA', {
                timeZone: tz,
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                hour12: false
            }).formatToParts(dt)
            const m = {}
            for (const { type, value } of parts) m[type] = value

            // Milliseconds preserved; timezone doesn't change fractional seconds
            const ms = String(dt.getUTCMilliseconds()).padStart(3, '0')

            // Compute numeric timezone offset for the supplied timeZone
            const dtf = new Intl.DateTimeFormat('en-US', {
                timeZone: tz,
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                hour12: false
            })
            const p2 = dtf.formatToParts(dt)
            const map = {}
            for (const { type, value } of p2) map[type] = value
            const asUTC = Date.UTC(
                Number(map.year), Number(map.month) - 1, Number(map.day),
                Number(map.hour), Number(map.minute), Number(map.second),
                dt.getUTCMilliseconds()
            )
            // Round to nearest minute to avoid truncation-induced 1-minute drift
            const offsetMs = asUTC - dt.getTime()
            const totalMinutes = Math.round(offsetMs / 60000)
            const sign = totalMinutes >= 0 ? '+' : '-'
            const absMin = Math.abs(totalMinutes)
            const offH = String(Math.floor(absMin / 60)).padStart(2, '0')
            const offM = String(absMin % 60).padStart(2, '0')
            const offsetStr = `${sign}${offH}:${offM}`

            // Map to common abbreviations for selected zones (based on current offset)
            const abbrMap = {
                'UTC': { '+00:00': 'Z' },
                'America/Los_Angeles': { '-08:00': 'PST', '-07:00': 'PDT' },
                'America/Denver': { '-07:00': 'MST', '-06:00': 'MDT' },
                'America/Chicago': { '-06:00': 'CST', '-05:00': 'CDT' },
                'America/New_York': { '-05:00': 'EST', '-04:00': 'EDT' },
                'Asia/Kolkata': { '+05:30': 'IST' },
                'Asia/Shanghai': { '+08:00': 'CST' },
                'Asia/Tokyo': { '+09:00': 'JST' },
                'Asia/Singapore': { '+08:00': 'SGT' },
            }

            const zoneAbbr = (abbrMap[tz] && abbrMap[tz][offsetStr]) || ''

            const base = `${m.year}-${m.month}-${m.day}T${m.hour}:${m.minute}:${m.second}.${ms}`
            if (tz === 'UTC') {
                return { primary: `${base}Z`, secondary: '', title: dt.toISOString() }
            }
            const suffix = `${offsetStr}${zoneAbbr ? ' ' + zoneAbbr : ''}`
            return { primary: base, secondary: suffix, title: dt.toISOString() }
        } catch (e) {
            return { primary: isoString, secondary: '', title: isoString }
        }
    }

    return (
        
            
                <Grid item lg={3} sm={6} xs={12}>
                    <Card component={Box} boxShadow={10} style={{marginBottom : "60px"}}>
                        <CardHeader style={{ backgroundColor: "#e3f2fd" }}
                            subheaderTypographyProps={{ variant: 'subtitle1' }}

                            title={props.dataId}

                            subheader={(
                                (() => {
                                    const ts = fmtDateTime(props.dateTime, props.timeZone)
                                    return (
                                        <span title={ts.title} style={{ display: 'inline-block' }}>
                                            {ts.primary}
                                            {ts.secondary && (
                                                <>
                                                    <br/>
                                                    <Box component="span" display="inline-flex" justifyContent="center" width="100%" mt={0.5}>
                                                        <Chip
                                                            size="small"
                                                            variant="outlined"
                                                            color="primary"
                                                            icon={<AccessTimeTwoToneIcon style={{ fontSize: 16 }} />}
                                                            label={ts.secondary}
                                                        />
                                                    </Box>
                                                </>
                                            ) }
                                        </span>
                                    )
                                })()
                            )}
                            avatar={
                                <Avatar style={{ backgroundColor: purple[300] }}><b>{ props.msgType }</b></Avatar>
                            }
                        />
                        <Divider />
                        <CardContent >

                        {
                            props.carrier &&
                        <>
                        <Typography title="Carrier" align="center" variant="h5">
                            <SignalCellularAltTwoToneIcon style={{ color: blue[700] }} />
                        <img 
                            src={`/carrier-logos/${props.carrier}.png`}
                            alt={`${props.carrier} Logo`}
                            style={{ height: props.carrier === "TMO" || props.carrier === "VZW"? "30px" : "35px", marginLeft: "8px" }}
                        />
                        </Typography>
                        
                        <Divider />
                        </>
                     }

                            <Typography align="center" variant="h5"><PhoneIcon style={{ color: deepOrange[500] }} /> { props.phone }</Typography>
                            <Divider />
                            <Typography title="Campaign" align="center" variant="subtitle1">
                                <VpnLockTwoToneIcon color="primary" /> &nbsp;{props.campaign!=="NULL" ? props.campaign : "DEFAULT(NULL)"}
                             </Typography>
                            

                            {
                                props.campaignID && props.leadID &&
                            <>
                            <Divider />
                            <Typography title="Source" align="center" variant="subtitle1">
                                <FingerprintTwoToneIcon color="primary" /> &nbsp;{props.campaignID!=="AGENT-MT" ? 
                                                                                `${props.campaignID}-${props.leadID}`
                                                                                : `${props.campaignID} ${props.leadID}`
                                                                                }
                             </Typography>
                            </>
                        }

                            <Divider />
                            <Typography align="center" variant="subtitle1">
                                <MessageIcon color="primary" /> &nbsp;{props.text}
                             </Typography>
                            <Divider />
                            <Typography align="center" variant="subtitle1">
                                <Tooltip title="SimBox Port">
                                    <RouterRoundedIcon color="primary" />
                                </Tooltip>
                                &nbsp;{ props.simBoxPort } &nbsp;
                                <Tooltip title="SIM Port">
                                    <SimCardTwoToneIcon style={{ color: orange[700] }} />
                                </Tooltip>
                                &nbsp;{ props.port }
                                { (props.subPort || props.subPort === 0) && (
                                    <>
                                        &nbsp;
                                        <Tooltip title="Sub Port">
                                            <MemoryTwoToneIcon style={{ color: deepOrange[600] }} />
                                        </Tooltip>
                                        &nbsp;{ props.subPort }
                                    </>
                                ) }
                            </Typography>
                            <Divider />
                            <Typography style={{ textTransform: "capitalize"  }} align="center" variant="body1"><InfoTwoToneIcon color="secondary" /> { props.dlrStatus || "Pending" }</Typography>

                        </CardContent>


                        <CardActions style={{ backgroundColor: "#3f51b5" }} >
                            <Button startIcon={<ReadMoreIcon/>} fullWidth variant="contained" color="primary">More Details</Button>
                        </CardActions>
                    </Card>
                </Grid>




            

        
    );
}

export default MessagesCards
